import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePhasrMonitoredRulesGrid = document.createElement('template');

templatePhasrMonitoredRulesGrid.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <header class='page__header'>
      <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <div class='wrapper'>
    <div class='phasr-monitored-rules-grid-content'>
      <div class='phasr-monitored-rules-grid'>
        <gz-grid-view showGlobalActions>
        </gz-grid-view>
      </div>
    </div>
  </div>
`;
